import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
    clearLoginFailure,
    initiateLoginReset,
    loginAction,
    LOGIN_TOO_MANY_ATTEMPTS
} from "../../store/auth/authActions";
import {
    selectIsLoggedIn,
    selectIsLoginFailed,
    selectLoginFailureReason,
    selectLoginResetResult,
    selectLoginResetResultError
} from "../../store/auth/authSelector";
import { useTranslation } from "react-i18next";
import { i18_TRANSLATION } from "../../i18nReferences";
import i18n from "../../i18n";
import LoginView from "./LoginView";
import LoginContainer from "./LoginContainer";

/**
 * Container component for the login page (studio, artist code and password in one form)
 * Manages Redux state for the login and the request for a password reset link
 */
const LoginPageContainer = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation([i18_TRANSLATION]);
    const isLoginFailed = useSelector(state => selectIsLoginFailed(state));
    const loginFailureReason = useSelector(state => selectLoginFailureReason(state));
    const isLoggedIn = useSelector(state => selectIsLoggedIn(state));
    const loginResetResult = useSelector(state => selectLoginResetResult(state));
    const loginResetResultError = useSelector(state => selectLoginResetResultError(state));

    useEffect(() => {
        dispatch(clearLoginFailure());
    }, [dispatch]);

    const loginFailedText = loginFailureReason === LOGIN_TOO_MANY_ATTEMPTS
        ? t('LOGIN_ARTIST.TOO_MANY_ATTEMPTS_TEXT', { ns: i18_TRANSLATION, defaultValue: 'Zu viele Versuche. Bitte später erneut versuchen.' })
        : t('LOGIN_ARTIST.FAILED_TEXT');
    const loginHandler = data => dispatch(loginAction(data));
    const handleReset = ({ studio, artist }) => dispatch(initiateLoginReset({ studio, artist, locale: i18n.language }));

    return (
        <LoginContainer maxWidth="xl">
            <LoginView
                t={t}
                onSubmit={loginHandler}
                isLoginFailed={isLoginFailed}
                isLoggedIn={isLoggedIn}
                successText={t('LOGIN_ARTIST.SUCCESS_TEXT')}
                loginFailedText={loginFailedText}
                onClickReset={handleReset}
                loginResetResult={loginResetResult}
                loginResetError={loginResetResultError}
            />
        </LoginContainer>
    );
};

export default LoginPageContainer;
